import { useMemo, useState } from "react"
import { MenuItem } from "@mui/material"
import { MRT_ColumnDef } from "material-react-table"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { useApiQueryTable } from "../../../../../../core/api/components/ApiQueryTable"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { Admin } from "../../../../../users/userTypes"
import { UserDetailsDialog } from "../../../../../office/admin/components/UserDetails/UserDetailsDialog"
import {
    fetchSupplierAdmins,
    FetchSupplierAdminsResponse,
    SupplierAdminsQuery,
} from "../../../account/administrators/supplierAdminApi"
import { useCurrentSupplier } from "../../../../../suppliers/supplierHooks"
import { UserType } from "../../../../../login/loginTypes"

function transformData(data: FetchSupplierAdminsResponse) {
    return data.administrators
}

export function SupplierMerchantsAdministratorsTable() {
    const [showDetailsModal, setShowDetailsModal] = useState(false)
    const [user, setUser] = useState<Admin>()

    const { l10n } = useAppLocalization()
    const { supplierId } = useCurrentSupplier()

    const supplierAdmins = useApiQuery(fetchSupplierAdmins, {
        queryName: SupplierAdminsQuery.ADMINS_FOR_SUPPLIER,
        dependencies: {
            supplierId,
            userType: UserType.MERCHANT,
        },
        select: transformData,
    })

    const { ApiQueryTable, columnFactory } = useApiQueryTable(supplierAdmins)

    const columns = useMemo<MRT_ColumnDef<Admin>[]>(
        () => [
            columnFactory.nameColumn({
                header: l10n.getString("name"),
                accessorKey: "user.displayName",
            }),
            columnFactory.shortNameColumn({
                header: l10n.getString("email"),
                accessorKey: "user.email",
            }),
            columnFactory.shortNameColumn({
                header: l10n.getString("supplier-users-table-merchant-column"),
                accessorKey: "merchantDetails.companyName",
            }),
            columnFactory.activeInactiveStatusColumn(
                {
                    id: "is-active",
                    header: l10n.getString("status"),
                },
                (row) => row.user.isActive,
            ),
        ],
        [l10n, columnFactory],
    )

    return (
        <>
            <ApiQueryTable
                columns={columns}
                initialState={{ density: "spacious" }}
                renderRowActionMenuItems={({ row, closeMenu }) => [
                    <LocalizedStrict id="office-manager-user-show-details">
                        <MenuItem
                            key={row.original.user.id}
                            onClick={() => {
                                setUser(row.original)
                                setShowDetailsModal(true)
                                closeMenu()
                            }}
                        >
                            Show details
                        </MenuItem>
                    </LocalizedStrict>,
                ]}
            />
            {user && (
                <UserDetailsDialog
                    key={user.user.id}
                    userId={user?.user.id}
                    userType="admin"
                    open={showDetailsModal}
                    onClose={() => {
                        setShowDetailsModal(false)
                    }}
                />
            )}
        </>
    )
}
